import { useBillingCurrency } from "$global-providers/billing-provider/provider";
import { useMemo } from "react";

export default function useCurrencyFormat(
  overrideCurrency?: ReturnType<typeof useBillingCurrency>,
) {
  const billingCurrency = useBillingCurrency();
  const currency = overrideCurrency ?? billingCurrency;

  return useMemo(() => {
    if (!currency?.format) {
      return undefined;
    }

    // if for new countries, we do not want to show decimals, you can use currency.format.compact;
    // for now, for KE and GH, we want to show 2 decimals: https://elephanthealthcare.atlassian.net/browse/TPAN-203
    const digits = 2;

    return new Intl.NumberFormat(currency.format.locale, {
      style: "currency",
      currency: currency.code,
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
    });
  }, [currency]);
}
